import { useMemo } from 'react';
import type { DmNotificationPatientRow } from '../../../../services/dmNotifications';
import { useLeavingNotifications } from '../useLeavingNotifications';
import { sortNotificationCards } from './notificationCardSort';
import { useNotificationCardSort } from './useNotificationCardSort';

export function useOpenNotificationCards(patient: DmNotificationPatientRow) {
    const rows = useMemo(() => [patient], [patient]);
    const { leavingIds, hiddenIds, markLeaving } = useLeavingNotifications(rows);
    const { sort, selectSort } = useNotificationCardSort();
    // Sorted before rendering; cards stay keyed by id, so a fold-away survives a re-sort.
    const visible = useMemo(
        () =>
            sortNotificationCards(
                patient.notifications.filter((n) => !hiddenIds.has(n.id)),
                sort
            ),
        [patient.notifications, hiddenIds, sort]
    );
    const openCount = visible.filter((n) => !leavingIds.has(n.id)).length;
    return { visible, openCount, leavingIds, markLeaving, sort, selectSort };
}
